import { Menu } from "antd";
import {
  dashboard_icon,
  dashboard_white_icon,
  delegates_icon,
  delegates_white_icon,
  events_icon,
  events_white_icon,
  logout_icon,
  sponsors_icon,
  sponsors_white_icon,
  support_icon,
  support_white_icon,
  tickets_icon,
  tickets_white_icon,
} from "../../assets/icons/icons";
import { NotificationOutlined } from "@ant-design/icons";
import { logo } from "../../assets/images/images";
import { useNavigate } from "react-router-dom";
import { deleteCurrentToken, deleteKeyFromStorage } from "../../helpers/helpers";

const SideBar = ({ selected }) => {

  const role = localStorage.getItem("adminRole");
  console.log("role", role);
  const navigate = useNavigate();
  const onClick = (e) => {
    e.key === "1" && navigate("/dashboard");
    e.key === "2" && navigate("/event");
    e.key === "3" && navigate("/sponsors");
    e.key === "4" && navigate("/delegates");
    e.key === "5" && navigate("/announcements");
    e.key === "6" && navigate("/tickets");
    e.key === "7" && navigate("/create-employee");
    e.key === "9" && navigate("/analytics");
    if (e.key === "8") {
      navigate("/");
      // deleteKeyFromStorage("token");
      deleteCurrentToken()
    }
  };
  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }


  const roleBasedItems = {
    // superAdmin: ["1", "2", "3", "5", "6", "7", "9"], 
    staffAdmin: ["1", "2", "5", "6", "8", "9"],
    contentAdmin: ["1", "2", "5", "8", "9"],

  };

  const items = [
    getItem(
      <p
        className={`${selected === "1" ? "text-white" : "text-themeGray-dark"
          } font-semibold text-base`}
      >
        Dashboard
      </p>,
      "1",
      <div
        className={`${selected === "1" ? "bg-primary" : "bg-themeGray-light"
          } h-8 w-8 rounded-full flex justify-center items-center`}
      >
        <img
          src={selected === "1" ? dashboard_white_icon : dashboard_icon}
          width={15}
          height={15}
          alt=""
        />
      </div>
    ),
    getItem(
      <p
        className={`${selected === "2" ? "text-white" : "text-themeGray-dark"
          } font-semibold text-base`}
      >
        Events
      </p>,
      "2",
      <div
        className={`${selected === "2" ? "bg-primary" : "bg-themeGray-light"
          } h-8 w-8 rounded-full flex justify-center items-center`}
      >
        <img
          src={selected === "2" ? events_white_icon : events_icon}
          width={15}
          height={15}
          alt=""
        />
      </div>
    ),
    getItem(
      <p
        className={`${selected === "3" ? "text-white" : "text-themeGray-dark"
          } font-semibold text-base`}
      >
        Sponsors
      </p>,
      "3",
      <div
        className={`${selected === "3" ? "bg-primary" : "bg-themeGray-light"
          } h-8 w-8 rounded-full flex justify-center items-center`}
      >
        <img
          src={selected === "3" ? sponsors_white_icon : sponsors_icon}
          width={15}
          height={15}
          alt=""
        />
      </div>
    ),
    getItem(
      <p
        className={`${selected === "4" ? "text-white" : "text-themeGray-dark"
          } font-semibold text-base`}
      >
        Delegates
      </p>,
      "4",
      <div
        className={`${selected === "4" ? "bg-primary" : "bg-themeGray-light"
          } h-8 w-8 rounded-full flex justify-center items-center`}
      >
        <img
          src={selected === "4" ? delegates_white_icon : delegates_icon}
          width={15}
          height={15}
          alt=""
        />
      </div>
    ),
    getItem(
      <p
        className={`${selected === "5" ? "text-white" : "text-themeGray-dark"
          } font-semibold text-base`}
      >
        Announcements
      </p>,
      "5",
      <div
        className={`${selected === "5" ? "bg-primary" : "bg-themeGray-light"
          } h-8 w-8 rounded-full flex justify-center items-center`}
      >
        <NotificationOutlined
          className={`${selected === "5" ? "text-white" : "text-primary"}`}
        />
      </div>
    ),
    getItem(
      <p
        className={`${selected === "6" ? "text-white" : "text-themeGray-dark"
          } font-semibold text-base`}
      >
        Tickets
      </p>,
      "6",
      <div
        className={`${selected === "6" ? "bg-primary" : "bg-themeGray-light"
          } h-8 w-8 rounded-full flex justify-center items-center`}
      >
        <img
          src={selected === "6" ? tickets_white_icon : tickets_icon}
          width={15}
          height={15}
          alt=""
        />
      </div>
    ),

    getItem(
      <p
        className={`${selected === "7" ? "text-white" : "text-themeGray-dark"
          } font-semibold text-base`}
      >
        Create Employee
      </p>,
      "7",
      <div
        className={`${selected === "7" ? "bg-primary" : "bg-themeGray-light"
          } h-8 w-8 rounded-full flex justify-center items-center`}
      >
        <img
          src={selected === "7" ? sponsors_white_icon : sponsors_icon}
          width={15}
          height={15}
          alt=""
        />
      </div>
    ),
    getItem(
      <p
        className={`${selected === "9" ? "text-white" : "text-themeGray-dark"
          } font-semibold text-base`}
      >
        Analytics
      </p>,
      "9",
      <div
        className={`${selected === "9" ? "bg-primary" : "bg-themeGray-light"
          } h-8 w-8 rounded-full flex justify-center items-center`}
      >
        <img
          src={selected === "9" ? dashboard_white_icon : dashboard_icon}
          width={15}
          height={15}
          alt=""
        />
      </div>
    ),

    getItem(
      <p
        className={`${selected === "8" ? "text-themeBlack" : "text-themeGray-dark"
          } font-semibold text-base`}
      >
        Log Out
      </p>,
      "8",
      <div
        className={`${selected === "8" ? "bg-primary" : "bg-themeGray-light"
          } h-8 w-8 rounded-full flex justify-center items-center`}
      >
        <img src={logout_icon} width={15} height={15} alt="" />
      </div>
    ),
  ];



  // const allowedKeys = roleBasedItems[role] || [];
  // const filteredItems = items.filter((item) => allowedKeys.includes(item.key));

  const allowedKeys = role && roleBasedItems[role] ? roleBasedItems[role] : items.map(i => i.key);
  const filteredItems = items.filter((item) => allowedKeys.includes(item.key));


  return (
    <div className="bg-white no-scrollbar sticky top-0 h-screen overflow-y-auto space-y-20">
      <div className="flex justify-center items-center my-16">
        <img src={logo} width={250} height={190} alt="" />
      </div>
      <Menu
        onClick={onClick}
        defaultSelectedKeys={[selected]}
        defaultOpenKeys={["sub1"]}
        mode="inline"
        items={filteredItems}
        className="px-6"
      />
    </div>
  );
};

export default SideBar;
